import React, { forwardRef, useState } from "react";

type Props = React.InputHTMLAttributes<HTMLInputElement>;

const formatPhone = (value: string) => {
  const digits = value.replace(/\D/g, "");

  if (digits.length <= 10) {
    // (99) 9999-9999
    return digits.replace(/^(\d{2})(\d)/, "($1) $2").replace(/(\d{4})(\d)/, "$1-$2");
  } else {
    // (99) 99999-9999
    return digits.replace(/^(\d{2})(\d)/, "($1) $2").replace(/(\d{5})(\d)/, "$1-$2");
  }
};

export const MaskedInputPhone = forwardRef<HTMLInputElement, Props>(
  ({ onChange, ...props }, ref) => {
    const [value, setValue] = useState(props.value);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const raw = e.target.value;
      const masked = formatPhone(raw);
      setValue(masked);

      const syntheticEvent = {
        ...e,
        target: {
          ...e.target,
          value: masked,
        },
      };

      onChange?.(syntheticEvent as React.ChangeEvent<HTMLInputElement>);
    };

    return (
      <input
        {...props}
        ref={ref}
        value={value}
        onChange={handleChange}
        maxLength={15}
        inputMode="numeric"
        // pattern="\\d*"
      />
    );
  }
);

MaskedInputPhone.displayName = "MaskedInputPhone";
